/** Device Entry query flag marking the editable guided `/my` flow; any other entry is read-only. */
export const DEVICE_ENTRY_GUIDED_PARAM = 'from';
export const DEVICE_ENTRY_GUIDED_VALUE = 'my';
